<div class='delivery-events-tab1-part'>
	This is tab 1
</div>